export default axios => ({
  index(projectId, payload = null) {
    return axios.get(`projects/${projectId}/complete-heat-map`, payload);
  }
})
